import { render } from "./UsersByCountry.vue?vue&type=template&id=2b8f5b92&ts=true"
import script from "./UsersByCountry.vue?vue&type=script&lang=ts"
export * from "./UsersByCountry.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__